import React from "react";
import { AppBar, Toolbar, Button, Box } from "@mui/material";
import { Link, useLocation } from "react-router-dom";

/**
 * Header component per la navigazione pubblica.
 * Mostra solo i link pubblici.
 */
function Header() {
  const location = useLocation();

  const isCurrentPath = (path) => {
    return location.pathname === path;
  };

  const buttonStyle = (path) => ({
    color: "inherit",
    backgroundColor: isCurrentPath(path)
      ? "rgba(255, 255, 255, 0.1)"
      : "transparent",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.2)",
    },
  });

  return (
    <AppBar position="static">
      <Toolbar>
        <Box
          component={Link}
          to="/"
          sx={{
            flexGrow: 1,
            textDecoration: "none",
            color: "inherit",
            display: "flex",
            alignItems: "center",
          }}
        >
          <img
            src="/questo-cheto-logo-ext-white.webp"
            alt="Questo è Cheto Logo"
            style={{ height: 40, marginRight: 8 }}
          />
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Button
            sx={buttonStyle("/")}
            component={Link}
            to="/onboarding/step/1"
          >
            Scopri il tuo piano
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
